import { Injectable } from '@angular/core';
import { Backend } from '../../_models/backend';
import { BehaviorSubject } from 'rxjs';
import StudentProfileResponse = Backend.StudentProfileResponse;
import ZoomMeetingInfoDTO = Backend.ZoomMeetingInfoDTO;
import TeacherType = Backend.TeacherType;

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  // app version
  public appVersion: string | null = null;
  public isVersionModalOpen = false;
  public updateVersionLater = false;

  // account type
  public accountType: TeacherType | null | undefined;

  // profile
  private profileSubject$ = new BehaviorSubject<StudentProfileResponse | undefined>(undefined);
  public readonly profile$ = this.profileSubject$.asObservable();

  // show change password modal
  private changePasswordSubject$ = new BehaviorSubject<boolean>(false);
  public readonly changePassword$ = this.changePasswordSubject$.asObservable();

  // zoom
  private zoomStartedSubject$ = new BehaviorSubject<{meetingInfo: ZoomMeetingInfoDTO, join: boolean} | null>(null);
  public readonly zoomStarted$ = this.zoomStartedSubject$.asObservable();

  public zoomClientConnected = false;

  public readonly zoomWithJoinLink = false;
  public readonly showZoomAuthorizeBtn = false;

  // scroll event
  private scrollSubject$ = new BehaviorSubject<{x: number, y: number} | null>(null);
  public readonly scroll$ = this.scrollSubject$.asObservable();
  scrolling = false;

  // app in background check
  doAppInBackgroundCheck = true;

  constructor() {
  }

  isSchoolAccount(): boolean {
    return this.accountType == null || this.accountType === 'SCHOOL';
  }

  isKidsAccount(): boolean {
    return this.accountType != null && this.accountType === 'PRESCHOOL';
  }

  isProAccount(): boolean {
    return this.accountType != null && this.accountType === 'BUSINESS';
  }

  showLicenceWarning(showLicenceWarning: boolean): void {
    if (showLicenceWarning) {
      const watermark = document.getElementById('watermark');
      if (watermark != null) {
        watermark.style.display = 'block';
      }
    }
  }

  get profile(): StudentProfileResponse | undefined {
    return this.profileSubject$.getValue();
  }

  set profile(profile: StudentProfileResponse | undefined) {
    this.profileSubject$.next(profile);
  }

  get changePassword(): boolean {
    return this.changePasswordSubject$.getValue();
  }

  set changePassword(changePassword: boolean) {
    this.changePasswordSubject$.next(changePassword);
  }

  get zoomStarted(): {meetingInfo: ZoomMeetingInfoDTO, join: boolean} | null {
    return this.zoomStartedSubject$.getValue();
  }

  set zoomStarted(meeting: {meetingInfo: ZoomMeetingInfoDTO, join: boolean} | null) {
    this.zoomStartedSubject$.next(meeting);
  }

  get scroll(): {x: number, y: number} | null {
    return this.scrollSubject$.getValue();
  }

  set scroll(position: {x: number, y: number} | null) {
    this.scrollSubject$.next(position);
  }
}
